/**
 * API client for making requests to the backend
 */
import { getApiBase } from '../config.js';

const apiBase = new URL(getApiBase());

/**
 * Fetch data from an endpoint
 * @param {string} endpoint - The API endpoint path
 * @returns {Promise<Object>} The JSON response
 */
export async function fetchAPI(endpoint) {
  const url = new URL(endpoint, apiBase);
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(`API error: ${response.statusText}`);
  }
  return response.json();
}

/**
 * Get user data by username
 * @param {string} username - The Last.fm username
 * @returns {Promise<Object>} User data
 */
export async function getUser(username) {
  return fetchAPI(`user/${username}`);
}

/**
 * Get weekly artist chart data
 * @param {number} chartsId - The chart ID
 * @returns {Promise<Object>} Chart data
 */
export async function getWeeklyArtistChart(chartsId) {
  return fetchAPI(`weeklyartistchart/${chartsId}`);
}

/**
 * Get artist details including similar artists
 * @param {number} artistId - The artist ID
 * @returns {Promise<Object>} Artist data
 */
export async function getArtist(artistId) {
  return fetchAPI(`artist/${artistId}`);
}

/**
 * Get all DJs
 * @returns {Promise<Object>} DJ data
 */
export async function getDJs() {
  return fetchAPI('djs');
}
